
import store from '@/store';
import { Options, Vue } from 'vue-class-component';

@Options({
  components:{
  },
  props: {
    restorant: {
            type: Object,
            required: true
        }
  }
})
export default class Restorants extends Vue {
  restorant!: any
  slide = 0;
  get slides(){
    return this.restorant.products.map((z: {id:string, name: any; image: any; })=>({id:z.id,title:this.restorant.name, subTitle:z.name,image:z.image}))
 
  }


  
}
